import { EDIT_MENU_ITEM_ENABLED } from "../../../../../utils/Constants";
import {
  buildDateRangePayload,
  createEmptyDateRange,
  DATE_RANGE_FIELDS,
  DATE_RANGE_REQUEST_FIELDS,
  getDateRangeFromPicker,
  isDateRangeComplete,
  isDateRangeInvalid,
} from "./dateRange.helpers";

// gate for the "edit sales (menu items)" action on a settled sale
// off by the feature flag; also hidden for bulk-settlement and split-payment sales
export const canEditMenuItem = (transactionData, enabled = EDIT_MENU_ITEM_ENABLED) =>
  enabled &&
  transactionData?.source !== "bulk_settlement" &&
  transactionData?.sales_type !== "split_payment";

// skip/limit batches can repeat a row when a sale is created between fetches,
// so keep the newest copy of each id when appending
export const mergeSalesPages = (loaded, nextBatch) =>
  Array.from(new Map([...loaded, ...nextBatch].map((sale) => [sale?._id, sale])).values());

export const createEmptySalesHistoryDateRange = () => ({
  ...createEmptyDateRange(),
});

export const SALES_HISTORY_DATE_RANGE_FIELDS = DATE_RANGE_FIELDS;
export const SALES_HISTORY_DATE_RANGE_REQUEST_FIELDS = DATE_RANGE_REQUEST_FIELDS;
export const getSalesHistoryDateRangeFromPicker = getDateRangeFromPicker;
export const isSalesHistoryDateRangeComplete = isDateRangeComplete;
export const isSalesHistoryDateRangeInvalid = isDateRangeInvalid;
export const buildSalesHistoryDateRangePayload = buildDateRangePayload;
